import MaskDom from './Mask';
import { wrapFC } from './Wrap';
const Overlay = wrapFC(MaskDom);
export default Overlay;
export { MaskDom };
